import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card/Card';
import { Button } from '@/components/ui/Button/Button';

interface NoResultsStateProps {
  onAdjustFilters?: () => void;
}

export function NoResultsState({ onAdjustFilters }: NoResultsStateProps) {
  return (
    <Card>
      <CardContent className="py-12 text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <Search className="w-8 h-8 text-gray-400" />
          </div>
        </div>
        <h3 className="text-lg font-semibold mb-2">No Venues Found</h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          We couldn't find any venues matching your criteria. Try broadening your search or adjusting your filters.
        </p>
        {onAdjustFilters && (
          <Button variant="secondary" onClick={onAdjustFilters}>
            Adjust Filters
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

